import { ComptaInvoice } from "./compta";

export class PharmacyProductUnit {
    id: string | null = null;
    name: string | null = null;
}

export class PharmacyProduct {
    id: number | null = null;
    userId: number | null = null;
    eventId: number | null = null;
    name: string | null = null;
    description: string | null = null;
    quantity: number | null = null;
    date: string | null = null;
    photoBase64: string | null = null;
    unit: PharmacyProductUnit | null = null;

    invoices: ComptaInvoice[] = [];
}
